<div class="my-4 mx-5">    
    <div class="wrapper mb-5">
        <!-- <div class="row align-items-center m-0" style="padding: 10px;">
            <img class="p-2" src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Redefinir senha</span>
        </div> -->
        <div class="component-box container-fluid">
            <div class="container-fluid pt-4">
                <div class="col-12 modal-header clean-modal-header">
                    <div class="col-md-12">
                        <h5 class="clean-modal-title">Redefinir senha</h5>
                        <p class="text-center">
                            Digite o código enviado ao seu e-mail e cadastre a nova senha
                        </p>
                    </div>
                </div>
                <ng-container *ngIf="false" [formGroup]="resetFormGroup" #resetForm="ngForm">
                    <div class="row mb-4 d-flex justify-content-center">
                        <div class="col-4">
                            <div class="custom-filter-input-container">
                                <mat-form-field class="w-100">
                                    <mat-label>CPF</mat-label>
                                    <input class="w-100" matInput formControlName="cpf" id="cpf" type="text" [textMask]="{mask: MASKS.cpf.textMask}">

                                    <mat-error *ngIf="formReset.cpf.invalid && (formReset.cpf.dirty || formReset.cpf.touched) && formReset.cpf.errors.required">
                                        O CPF é obrigatório
                                    </mat-error>
                                    <mat-error *ngIf="formReset.cpf.invalid && (formReset.cpf.dirty || formReset.cpf.touched) && formReset.cpf.errors.cpf">
                                        CPF inválido
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="custom-filter-input-container">
                                <mat-form-field class="w-100">
                                    <mat-label>Email</mat-label>
                                    <input class="w-100" matInput formControlName="email" id="email" type="email">

                                    <mat-error *ngIf="formReset.email.invalid && (formReset.email.dirty || formReset.email.touched) && (formReset.email.errors.required || formReset.email.errors.email)">
                                        O E-mail é obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-12 text-right button-container mt-5 mb-3">
                            
                        </div>
                    </div>
                </ng-container>
                <form *ngIf="true" [formGroup]="confirmFormGroup" #confirmForm="ngForm">
                    <div class="row mb-4 d-flex justify-content-center">
                        <div class="col-6">
                            <div class="titlePopover">Critérios de aceitação da senha</div>
                            <div class="content">
                            <ol>
                                <li>A senha deve somente ter números</li>
                                <li>A senha deve ter entre 6 a 10 dígitos</li>
                                <li>A senha não pode ser parte do CPF, data de nascimento ou número de telefone</li>
                                <li>Não é permitido dígitos iguais consecutivos. Exemplo: <span class="passExample">222222</span> ou <span class="passExample">222584</span></li>
                                <li>Só é permitido até 2 dígitos sequencias consecutivos. Exemplo: <span class="passExample">238462</span></li>
                            </ol>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="custom-filter-input-container mb-2">
                                <mat-form-field class="w-100">
                                    <mat-label>Código enviado por E-mail</mat-label>
                                    <input class="w-100" onlyNumber maxlength="6" matInput formControlName="token" id="token" type="text" type="text" autocomplete="off">

                                    <mat-error *ngIf="formConfirm.token.invalid && (formConfirm.token.dirty || formConfirm.token.touched) && formConfirm.token.errors.required">
                                        O código é obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="custom-filter-input-container mb-2">
                                <mat-form-field class="w-100">
                                    <mat-label>Nova senha</mat-label>
                                    <input class="w-100" onlyNumber matInput maxlength="10" formControlName="senha" id="senha" type="password">

                                    <mat-error *ngIf="formConfirm.senha.invalid && (formConfirm.senha.dirty || formConfirm.senha.touched) && formConfirm.senha.errors.required">
                                        A senha é obrigatória
                                    </mat-error>
                                    <mat-error *ngIf="formConfirm.senha.invalid && (formConfirm.senha.dirty || formConfirm.senha.touched) && formConfirm.senha.errors.minlength">
                                        Senha deve conter mais de 6 dígitos
                                    </mat-error>
                                    <mat-error *ngIf="formConfirm.senha.invalid && (formConfirm.senha.dirty || formConfirm.senha.touched) && formConfirm.senha.errors.maxlength">
                                        Senha deve conter no máximo 10 dígitos
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="custom-filter-input-container mb-2">
                                <mat-form-field class="w-100">
                                    <mat-label>Confirmar a nova senha</mat-label>
                                    <input class="w-100" onlyNumber matInput maxlength="10" formControlName="senhaConfirmacao" id="senhaConfirmacao" type="password">

                                    <mat-error *ngIf="formConfirm.senhaConfirmacao.invalid && (formConfirm.senhaConfirmacao.dirty || formConfirm.senhaConfirmacao.touched) && formConfirm.senhaConfirmacao.errors.required">
                                        A senha de confirmação é obrigatória
                                    </mat-error>
                                    <mat-error *ngIf="formConfirm.senhaConfirmacao.invalid && (formConfirm.senhaConfirmacao.dirty || formConfirm.senhaConfirmacao.touched) && formConfirm.senhaConfirmacao.errors.mustMatch">
                                        As senhas devem coincidir
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="custom-filter-input-container text-right button-container my-3">
                                <button type="submit" class="custom-button-full" (click)="continueConfirm(confirmFormGroup.value)">
                                    Redefinir senha
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #popoverContent>
    <div class="titlePopover">Critérios de aceitação da senha</div>
    <div class="content">
      <ol>
          <li>A senha deve somente ter números</li>
          <li>A senha deve ter entre 6 a 10 dígitos</li>
          <li>A senha não pode ser parte do CPF, data de nascimento ou número de telefone</li>
          <li>Não é permitido dígitos iguais consecutivos. Exemplo: <span class="passExample">222222</span> ou <span class="passExample">222584</span></li>
          <li>Só é permitido até 2 dígitos sequencias consecutivos. Exemplo: <span class="passExample">238462</span></li>
      </ol>
    </div>
</ng-template>